export const ADMIN_EMAILS = ['paklawsites@gmail.com', 'paklawsites@gmail.com', 'babaralirai1993@gmail.com'];

export const isSuperAdminEmail = (email: string | null | undefined): boolean => {
  if (!email) return false;
  return ADMIN_EMAILS.includes(email.toLowerCase());
};
